<template>
  <div class="visitorGuide">
    <div class="visitorGuide-card">
      <div class="card-title">{{ lan ? "Opening Hours" : "开馆时间" }}</div>
      <div class="card-time">10:00-18:00</div>
      <div class="card-time" v-if="lan">
        Tuesday to Sunday <br />
        Closed on Mondays, Excluding Holidays
      </div>
      <div class="card-time" v-else>
        周二至周日（每逢周一闭馆，节假日正常开放）
      </div>
    </div>
    <div class="grey-line"></div>
    <div class="visitorGuide-card">
      <div class="card-title">{{ lan ? "Admission Ticket" : "票价" }}</div>
      <div class="guide-info-title">
        {{ lan ? "General Admission" : "成人票" }}
      </div>
      <div class="guide-info-dec">
        {{
          lan
            ? "RMB 120, tickets available online or onsite"
            : "120元/人，适用于微信塱头古村小程序及现场购票"
        }}
      </div>
      <div class="guide-info-title">
        {{ lan ? "Student Admission" : "学生票" }}
      </div>
      <div class="guide-info-dec" v-if="lan">
        RMB 60, tickets available online or onsite. <br />
        Present valid student ID upon admission
      </div>
      <div class="guide-info-dec" v-else>
        60元/人，适用于微信塱头古村小程序及现场购票
      </div>
      <div class="guide-info-title">
        {{ lan ? "Special Admission" : "优待票" }}
      </div>
      <div class="guide-info-dec" v-if="lan">
        RMB 72, tickets available onsite only. <br />
        Local residents - Residents with Huadu household registration enjoy
        discounts by presenting their ID cards.
      </div>
      <div class="guide-info-dec" v-else>
        72元/人，适用于花都本地居民，凭身份证现场购票
      </div>
      <div class="guide-info-title">
        {{ lan ? "Adult Double Ticket" : "成人双人票（需同时进馆）" }}
      </div>
      <div class="guide-info-dec" v-if="lan">
        RMB 180 for two adults，tickets available online or onsite. <br />
        Admission requires both guests to enter together.
      </div>
      <div class="guide-info-dec" v-else>
        180元/两人，适用于微信塱头古村小程序及现场购票
      </div>
      <div class="guide-info-title">{{ lan ? "Free Admission" : "免票" }}</div>
      <div class="guide-info-dec">
        {{
          lan
            ? "Free Admission with Valid ID"
            : "需携带相关证件现场核验，适用范围如下:"
        }}
        <br />
        {{
          lan
            ? "·Kid - Height of 1.4m and below."
            : "·儿童 - 身高1.4米（含）以下"
        }}<br />
        {{
          lan
            ? "·Senior - 60 years old and above with valid ID. "
            : "·老人 - 年龄在60周岁（含）以上 "
        }}<br />
        {{
          lan
            ? "·Other (with valid ID) - Soldier in active duty, veteran, people with disabilities, members of a martyr's family."
            : "·特定群体 - 现役军人、退役军人、残疾人、烈士遗属、建筑学专业在读学生（建筑学专业在读学生每人仅可享受1次免票）"
        }}
        <br />
        {{
          lan
            ? "·Student currently studying in the architecture major with Student ID card (one-time free admission per person)."
            : ""
        }}
      </div>
      <div class="guide-info-title">
        {{ lan ? "Group Admission" : "团体票" }}
      </div>
      <div class="guide-info-dec">
        {{
          lan
            ? "For inquiries, please contact the group ticket hotline at 020-22262888 (reservations must be made three days in advance)."
            : "20人起购，请拨打团队购票专线 020-22262888 进行咨询（需提前三天进行预约）"
        }}
      </div>
    </div>
    <div class="grey-line"></div>
    <div class="visitorGuide-card">
      <div class="card-title">{{ lan ? "Traffic Guide" : "交通指引" }}</div>
      <div class="guide-box">
        <img class="guide-img" src="@/assets/visitorGuide1.jpg" alt="" />
        <div class="guide-info">
          <div class="guide-info-title">{{ lan ? "Address" : "地址" }}:</div>
          <div class="guide-info-dec">
            {{
              lan
                ? "No. 18 Qingyun Road, Langtou Village, Tanbu Town, Huadu District, Guangzhou City"
                : "广州市花都区炭步镇朗头村青云路18号"
            }}
          </div>
          <div class="guide-info-title">
            {{ lan ? "Public transportation" : "公共交通" }}：
          </div>
          <div class="guide-info-dec">
            {{
              lan
                ? "Take Guangzhou Metro Line 9 to Fei'eling Station, transfer to Huadu No. 15 to reach Langtou Village, or take a taxi from the subway station to ChunYangTai, which is a 10-15 minute drive away."
                : " 广州地铁9号线“飞鹅岭”站，转乘花15路即可到达朗头村，或地铁出站后打车至“春阳台”，10-15分钟车程到达"
            }}
          </div>
          <div class="guide-info-title">
            {{ lan ? "Self-driving route" : "自驾推荐" }}:
          </div>
          <div class="guide-info-dec">
            {{
              lan
                ? "Locate the 'Langtou Ancient Village Parking Lot' (about 1 hour drive from Guangzhou and Foshan), turn left at the parking lot entrance and walk for 1 minute to reach ChunYangTai."
                : "定位至“塱头古村停车场”（广佛自驾约1小时车程），在停车场入口左转步行1分钟即到达春阳台"
            }}
          </div>
        </div>
      </div>
    </div>
    <div class="grey-line"></div>
    <div class="visitorGuide-card">
      <div class="card-title">{{ lan ? "Floor Guide" : "楼层指引" }}</div>

      <div class="visitor-guide">
        <img class="visitor-floor-last" src="@/assets/map2.jpg" alt="" />
      </div>
    </div>
    <div class="grey-line"></div>
    <div class="visitorGuide-card" v-if="visitorNoticeList.length">
      <div class="card-title">
        {{ lan ? "Notice to Visitors" : "游客须知" }}
      </div>
      <div class="guide-info-dec">
        <div v-for="(item, index) in visitorNoticeList" :key="index">
          {{
            lan
              ? `${item.en || ""}`
              : `${item.cn || ""}`
          }}
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "visitorGuide",

  data() {
    return {
      isIndex: false,
      lan: this.$store.state.isEn,
      advertCnDetail: "",
      advertEnDetail: "",
      visitorNoticeList: [] // 添加这行
    };
  },
  watch: {
    "$store.state.isEn"() {
      this.lan = this.$store.state.isEn;
    },
  },
  created() {
    // 获取当前屏幕宽度
    let screenWidth = window.innerWidth || document.documentElement.clientWidth;
    if (screenWidth < 961) {
      this.isIndex = true;
    }
    // 创建一个媒体查询，检查屏幕的宽度是否大于或等于 768px
    this.mediaQuery = window.matchMedia("(min-width: 961px)");
    // 添加事件侦听器，在状态更改时收到通知
    this.mediaQuery.addListener(this.handleMediaQueryChange);
    this.getVisitorNotice();
  },
  beforeDestroy() {
    this.mediaQuery.removeListener(this.handleMediaQueryChange);
  },
  methods: {
    handleMediaQueryChange(event) {
      if (event.matches) {
        this.isIndex = false;
      } else {
        this.isIndex = true;
      }
    },
    processVisitorNotice() {
      // 将中英文内容按行分割
      const cnItems = this.advertCnDetail
        ? this.advertCnDetail.split("\n").filter((item) => item.trim())
        : [];
      const enItems = this.advertEnDetail
        ? this.advertEnDetail.split("\n").filter((item) => item.trim())
        : [];

      // 创建合并列表
      const maxLength = Math.max(cnItems.length, enItems.length);
      this.visitorNoticeList = [];
      for (let i = 0; i < maxLength; i++) {
        this.visitorNoticeList.push({
          cn: cnItems[i] || "",
          en: enItems[i] || "",
        });
      }
    },
    async getVisitorNotice() {
      await this.$api.get(
        "/advert/list",
        { current: 1, pageSize: 10, advertFlagName: "Visitor_Notice" },
        (r) => {
          const { data, code } = r;
          if (code == 0) {
            this.advertCnDetail = data[0].advertCnDetail;
            this.advertEnDetail = data[0].advertEnDetail;

            // 解析并处理游客须知数据
            this.processVisitorNotice();
          }
        }
      );
    },
  },
};
</script>

<style scoped>
.visitorGuide {
  width: 1440px;
  margin: 6% auto 80px;
}
.visitorGuide-card {
}
.grey-line {
  width: 100%;
  height: 1px;
  background: #d8d8d8;
  margin: 50px auto;
}
.card-title {
  font-family: SourceHanSansCN-Bold;
  font-size: 40px;
  color: #000000;
  letter-spacing: 0;
  text-align: left;
  font-weight: 700;
  margin-bottom: 24px;
}
.card-time {
  font-family: SourceHanSansCN-Regular;
  font-size: 18px;
  color: #000000;
  letter-spacing: 0;
  text-align: left;
  line-height: 32px;
  font-weight: 400;
}
.guide-box {
  display: flex;
  margin: 30px 0 50px;
}
.guide-img {
  width: 647px;
  height: 480px;
  object-fit: cover;
}
.guide-info {
  width: 647px;
  margin-left: 30px;
}
.guide-info-title {
  font-family: SourceHanSansCN-Bold;
  font-size: 20px;
  color: #000000;
  letter-spacing: 0;
  text-align: left;
  font-weight: 700;
}
.guide-info-dec {
  font-family: SourceHanSansCN-Regular;
  font-size: 18px;
  color: #000000;
  letter-spacing: 0;
  text-align: left;
  line-height: 32px;
  font-weight: 400;
  margin: 10px 0 34px;
}
.visitor-guide {
  display: flex;
  justify-content: space-between;
}
.visitor-floor-img {
  width: 442px;
  height: 268px;
}
.visitor-floor-last {
  width: 100%;
  height: auto;
  margin-top: 30px;
  object-fit: contain;
}
.visitor-info-img {
  width: 910px;
  height: 624px;
}
.visitor-info-img2 {
  width: 910px;
  height: 550px;
}
.visitor-info-img3 {
  width: 910px;
  height: 488px;
}
@media (max-width: 1440px) {
  .visitorGuide {
    width: 90%;
    margin: 110px auto 80px;
  }
  .visitorGuide-card {
  }
  .guide-img {
    object-fit: contain;
  }
  .grey-line {
    width: 100%;
    height: 1px;
    background: #d8d8d8;
    margin: 50px auto;
  }
}
@media (max-width: 960px) {
  .visitorGuide {
    width: 90%;
    margin: 100px auto 40px;
  }
  .visitorGuide-card {
    margin: 0 0 10px;
  }
  .grey-line {
    width: 100%;
    height: 1px;
    background: #d8d8d8;
    margin: 20px auto;
  }
  .card-title {
    font-family: SourceHanSansCN-Bold;
    font-size: 24px;
    color: #000000;
    letter-spacing: 0;
    text-align: left;
    font-weight: 700;
    margin-bottom: 16px;
  }
  .card-time {
    font-family: SourceHanSansCN-Regular;
    font-size: 15px;
    color: #000000;
    letter-spacing: 0;
    text-align: left;
    line-height: 24px;
    font-weight: 400;
  }
  .guide-box {
    display: block;
    margin: 0px 0 30px;
  }
  .guide-img {
    width: 100%;
    height: auto;
    object-fit: contain;
    margin: 0 0 10px;
  }
  .guide-info {
    width: 100%;
    margin-left: 0px;
  }
  .guide-info-title {
    font-family: SourceHanSansCN-Bold;
    font-size: 18px;
    color: #000000;
    letter-spacing: 0;
    text-align: left;
    font-weight: 700;
  }
  .guide-info-dec {
    font-family: SourceHanSansCN-Regular;
    font-size: 14px;
    color: #000000;
    letter-spacing: 0;
    text-align: left;
    line-height: 24px;
    font-weight: 400;
    margin: 10px 0 20px;
  }
  .visitor-guide {
    display: flex;
    justify-content: space-between;
  }
  .visitor-floor-img {
    width: 442px;
    height: 268px;
  }
  .visitor-floor-last {
    width: 100%;
    height: auto;
    margin: 10px auto;
    object-fit: contain;
  }
}
</style>
